import { atom } from "recoil";

export const gamesAllEditModalStore = atom({
	key: "gamesAllEditModalStore",
	default: {
		show: false,
		loaded: true,
		selectedItems: [],
		values: {
			active: null,
			listed: null,
			categoryID: null,
		},
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
